import { Component, OnInit } from '@angular/core';
import { Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';

@Component({
    selector: 'app-orikanconfigs',
    templateUrl: './orikanconfigs.component.html',
    styleUrls: ['./orikanconfigs.component.scss'],
    standalone: false
})
export class OrikanConfigsComponent implements OnInit {
  constructor() { }

  public Columns: Array<Datalistviewcolumn> = [
    new Datalistviewcolumn("Name", "Name"),
    new Datalistviewcolumn("Base URL", "BaseUrl"),
    new Datalistviewcolumn("Username", "Username"),
  ];

  ngOnInit(): void {}
}
